export default __webpack_public_path__ + "static/media/process-step2.0b76752c.svg";